import {TextField as SharedTextField, TextFieldType} from "@bounce/shared/consumer/bounce-ui";
import {outlinedInputSx} from "./inputStyles";

export const TextField = ({InputSx, ...props}: TextFieldType) => (
  <SharedTextField InputSx={{...outlinedInputSx, ...InputSx}} {...props} />
);

export type {TextFieldType};
